import { render, staticRenderFns } from "./yi-create-order-batch.vue?vue&type=template&id=67c35f9f&scoped=true&"
import script from "./yi-create-order-batch.vue?vue&type=script&lang=js&"
export * from "./yi-create-order-batch.vue?vue&type=script&lang=js&"
import style0 from "./yi-create-order-batch.vue?vue&type=style&index=0&id=67c35f9f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c35f9f",
  null
  
)

component.options.__file = "src/components/yi-create-order-batch/yi-create-order-batch.vue"
export default component.exports